<template>
  <div class="customer-navigation">
    <div class="customer-navigation__links">
      <nuxt-link
        :to="{ name: 'index' }"
        class="customer-navigation__link customer-navigation__link--magenta"
      >
        Telekom Zubehörshop
      </nuxt-link>

      <a
        class="customer-navigation__link"
        href="https://geschaeftskunden.telekom.de/"
        rel="noopener"
        target="_blank"
      >
        Geschäftskunden <span class="sr-only">(Der Link wird in einem neuen Tab geöffnet)</span>
        <SvgIcon :image="externalIcon" />
      </a>
    </div>
    <div class="customer-navigation__links">
      <a
        class="customer-navigation__link"
        href="https://www.telekom.de/telekom-shops"
        rel="noopener"
        target="_blank"
      >
        Telekom Shops <span class="sr-only">(Der Link wird in einem neuen Tab geöffnet)</span>
        <SvgIcon :image="externalIcon" />
      </a>
      <a
        class="customer-navigation__link"
        href="https://www.telekom.de/kontakt"
        rel="noopener"
        target="_blank"
      >
        Kontakt <span class="sr-only">(Der Link wird in einem neuen Tab geöffnet)</span>
        <SvgIcon :image="externalIcon" />
      </a>
    </div>
  </div>
</template>

<script>
import externalIcon from '~/assets/images/external-link.svg';

export default {
  name: 'CustomerNavigation',
  data() {
    return {
      externalIcon,
    };
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.customer-navigation {
  padding-top: $grid-base * 0.5;
  padding-bottom: $grid-base;
  margin-bottom: $grid-base * -0.5;
  padding-left: $grid-base;
  display: flex;
  justify-content: space-between;
  transition: opacity 0.4s $nav-timing-function;
  opacity: 1;

  @include mq(false, $mq-lg - 1) {
    display: none;
  }

  @include mq($mq-lg) {
    padding-left: $grid-base * 1.5;
  }

  &__links {
    @include font-size(12px, 14px);
    display: flex;
    gap: 2 * $grid-base;
  }

  &__link {
    color: var(--color-font);
    display: flex;
    align-items: center;
    gap: 2px;

    svg {
      width: 12px;
      height: 12px;
    }

    &:visited {
      color: var(--color-font);
    }

    &:hover,
    &:active,
    &:focus {
      color: color(magenta, 1000);
    }

    &--magenta {
      color: color(magenta, 1000);
      font-weight: 700;

      &:visited {
        color: color(magenta, 1000);
      }
    }
  }
}

body.nav-scrolled {
  .customer-navigation {
    @include mq($mq-lg) {
      opacity: 0;
    }
  }
}

body.nav-scrolled--complete {
  .customer-navigation {
    @include mq($mq-lg) {
      visibility: hidden;
    }
  }
}
</style>
